import React from "react";
import * as Icons from "lucide-react";
import { Card } from "@/components/ui/card";
import { Reveal, SectionTitle } from "./common";
import { BENEFITS } from "@/lib/site";

export const Benefits = () => {
  return (
    <section id="beneficios" className="py-14 sm:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6">
        <Reveal>
          <SectionTitle
            eyebrow="Para tu hijo y para ti"
            title="Más que un libro para colorear"
            subtitle="Un momento para conectar, aprender y crecer en familia — sin pantallas y sin frustraciones."
          />
        </Reveal>
        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4">
          {BENEFITS.map((b, i) => {
            const Icon = Icons[b.icon] || Icons.Heart;
            return (
              <Reveal key={b.title} delay={i * 0.06}>
                <Card
                  data-testid="benefit-card"
                  className="h-full rounded-2xl border-[hsl(var(--border))] bg-white p-6 shadow-[0_10px_30px_rgba(31,41,55,0.08)] transition-shadow duration-200 hover:shadow-[0_14px_40px_rgba(31,41,55,0.12)]"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[hsl(var(--brand-mint))]/35">
                    <Icon className="h-6 w-6 text-[hsl(var(--brand-coral))]" />
                  </span>
                  <h3 className="mt-4 font-heading text-lg font-bold text-[hsl(var(--brand-ink))]">{b.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{b.text}</p>
                </Card>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
